import { Store } from "./src/redux/store";

export const wrapRootElement = Store;
